import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import { faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import {
  getDealerEntry,
  getDealerEntryByDate,
  getDealerEntryExcelDownload,
  getDealerEntryPdfDownload,
  getDealerLExcel,
  putDealerEntry,
} from "../../Service/AllDealerEntryAPI";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Table from "react-bootstrap-table-next";
import axios from "../../utils/axiosInstance";
import cellEditFactory from "react-bootstrap-table2-editor";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import fileSaver from "file-saver";
import moment from "moment";
import swal from "sweetalert";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

// import "./addressHover.css";

export default () => {
  const [entries, setEntries] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [type, setType] = useState("dealer");
  // ----- pagination
  const [state, setState] = useState({});
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoaded, setisLoaded] = useState(false);
  const [changeRowData, setChangeRowData] = useState({
    selectedRow: [],
    cellChange: "",
    columnChange: [],
  });

  useEffect(() => {
    // ----- Function call to get dealer list
    getDealerList();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // ----- Function call to update dealer details
    putDealerDetailsChange();
    // eslint-disable-next-line
  }, [changeRowData]);

  const handlePageChange = async (page) => {
    setEntries([]);
    const selectedPage = page - 1;
    console.log("selectedPage", selectedPage);
    if (fromDate === "" && toDate === "") {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      // setisLoaded(true);
      await getDealerEntry(selectedPage, fkUserId, role, headers)
        .then((result) => {
          console.log("Get Pagination Dispatch Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            console.log("data", data);
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotaloffset(totalSize);
            entries.map((item, index) => (item.id = totalSize + index + 1));
            setisLoaded(false);
          } else {
            setisLoaded(false);
            swal("Sorry", "Dealer data is not present.", "warning");
          }
        })
        .catch((error) => console.error("Error", error));
    }
    // ----- Date wise pagination
    else if (fromDate !== "" && toDate !== "") {
      // setisLoaded(true);
      await getDealerEntryByDate(
        selectedPage,
        moment(fromDate).format("yyyy-MM-DD"),
        moment(toDate).format("yyyy-MM-DD")
      )
        .then((result) => {
          console.log("Get Pagination Date wise Dealer Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            entries.map((item, index) => (item.id = totalSize + index + 1));
            console.log("totalSize", totalSize);
            console.log("data", data);
            setEntries(data);
            setTotaloffset(totalSize);
            setTotalCount(result.data.totalElements);
            setisLoaded(false);
          } else {
            setisLoaded(false);
            swal(
              "Sorry",
              "Dealer data is not present for selected date",
              "warning"
            );
          }
        })
        .catch((error) => {
          console.log("Get Field Issue Error", error);
        });
    } else {
      swal("Failed", "Please select date", "error");
    }
  };

  // ----- Function declaration of get dealer list
  const getDealerList = async () => {
    try {
      setTimeout(async () => {
        const role = sessionStorage.getItem("role");
        const fkUserId = sessionStorage.getItem("pkUserId");
        const token = sessionStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };
        setisLoaded(true);
        await getDealerEntry(currentPage, fkUserId, role, headers)
          .then((result) => {
            console.log("Get Dealer Result", result);
            if (result?.data?.content?.length !== 0) {
              const data = result.data.content;
              setEntries(data);
              setPageCount(result.data.totalPages);
              setTotalCount(result.data.totalElements);
            } else {
              swal("Sorry", "Dealer data is not present", "warning");
            }
          })
          .catch((error) => {
            console.log("Get Dealer Entry Error", error);
          });
        setisLoaded(false);
      }, 200);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };
// old code for from date selection
  // ----- Function declaration for setting fromDate on "fromDate" field change event
  // const getDealerListByFromDate = (e) => {
  //   setFromDate(e.target.value);
  //   console.log(fromDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    // Clear the "To" date if it's before the selected "From" date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (date < fromDate) {
      swal('Invalid Date', 'The "To" date cannot be before the "From" date.', 'warning');
      setToDate(null); // Reset "To" date if invalid
    } else {
      setToDate(date);
    }
  };
// old code for TO  date selection
  // ----- Function declaration for setting toDate on "toDate" field change event
  // const getDealerListByToDate = async (e) => {
  //   setToDate(e.target.value);
  //   console.log(toDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  // ----- Function declaration for API call to get dealer list by date on "Search By Date" button click event
  const getDealerListByDate = async () => {
    try {
      setTimeout(async () => {
        setisLoaded(true);
        if (fromDate !== "" && toDate !== "") {

          await getDealerEntryByDate(
            currentPage,
            moment(fromDate).format("yyyy-MM-DD"),
            moment(toDate).format("yyyy-MM-DD")
          )
            .then((result) => {
              console.log("Get Dealer Entry Result", result);
              if (result?.data?.content?.length !== 0) {
                const data = result.data.content;
                setEntries(data);
                setPageCount(result.data.totalPages);
                setTotalCount(result.data.totalElements);
                setToDate("")
                setFromDate("")
              } else {
                setEntries([]);
                setPageCount();
                setTotalCount();
                swal(
                  "Sorry",
                  "Dealer data is not present for selected date.",
                  "warning"
                );
              }
            })
            .catch((error) => {
              console.log("Get Dealer Entry Error", error);
            });
        } else {
          swal("Failed", "Please select date", "error");
        }
        setisLoaded(false);
      }, 200);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  // ----- Function declaration to Download Dealer Pdf
  const DealerEntryPdfDownload = async () => {
    try {
      // ----- Pdf by filtering date
      if (fromDate !== "" && toDate !== "") {
        setisLoaded(true);
        await getDealerEntryPdfDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
        setisLoaded(false);
        setToDate("")
        setFromDate("")
      } else {
        setisLoaded(false);
        swal("Failed", "Please select date", "error");
      }
    } catch (error) {
      console.log(error);
      setisLoaded(false);
    }
  };

  // ----- Function declaration to update dealer details
  const putDealerDetailsChange = async () => {
    try {
      if (changeRowData?.selectedRow?.length !== 0) {
        // ----- Set selectedRow to edited row getting from child component
        const selectedRow = changeRowData.selectedRow;
        // ----- Set selectedRow's edited column with edited new value getting from child component
        selectedRow[changeRowData.columnChange] = changeRowData.cellChange;
        console.log("Change Dealer row", selectedRow);
        const loginUserName = sessionStorage.getItem("userName");
        // ----- Object for update dealer data
        const data = {
          pkDealerId: selectedRow.pkDealerId,
          dealerName: selectedRow.dealerName,
          customerName: selectedRow.customerName,
          fkCustomerId: selectedRow.fkCustomerId,
          dealerShipName: selectedRow.dealerShipName,
          mobileNo: selectedRow.mobileNo,
          email: selectedRow.email,
          country: selectedRow.country,
          state: selectedRow.state,
          city: selectedRow.city,
          pinCode: selectedRow.pinCode,
          address: selectedRow.address,
          siteType: selectedRow.siteType,
          discription: selectedRow.discription,
          userName: selectedRow.userName,
          password: selectedRow.password,
          role: selectedRow.role,
          status: selectedRow.status,
          createdOn: selectedRow.createdOn,
          createdBy: selectedRow.createdBy,
          modifiedBy: `${loginUserName}`,
        };
        console.log("Change Dealer datails", data);
        await putDealerEntry(data)
          .then((result) => {
            console.log("Dealer Result", result);
          })
          .catch((error) => {
            console.log("Dealer Error", error);
            swal("Failed", "Update dealer datails failed", "error");
          });
      }
    } catch (error) {
      console.log(error);
      // swal( "Failed", "Something went wrong please check your internet", "error" );
    }
  };

  // ----- Function declaration to Download Dealer Excel
  const getDealerExcelDownload = async () => {
    if (fromDate !== "" && toDate !== "") {
      // ----- Excel by filtering date
      try {
        await getDealerEntryExcelDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
        setToDate("")
        setFromDate("")
      } catch (error) {
        console.log("getDealerExcelDownload error :-", error);
      }
    } else {
      // ----- complete Excel
      try {
        let result = await getDealerLExcel();
        console.log("getDealerLExcel result :-", result);
        setToDate("")
        setFromDate("")
        let blob = new Blob([result.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(blob, "dealerList.xlsx");
      } catch (error) {
        console.log("getDealerLExcel error :-", error);
      }
    }
  };

  // ----- Adding SrNo column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));

  // ----- Column heading of Deler list
  const columns = [
    { dataField: "id", text: "Sr. No." },
    // { dataField: "status", text: "Status", },
    {
      dataField: "customerName",
      text: "Customer Name",
      // editable: false,
      //  formatter: (cell) => (!cell ? "NA" : cell)
    },
    {
      dataField: "dealerName",
      text: "Dealer Name",
    },
    {
      dataField: "createdOn",
      text: "Created Date",
      formatter: (cell) => {
        return <>{moment(cell).format("DD-MMM-YYYY")}</>;
      },
    },
    {
      dataField: "createdTime",
      text: "Created Time",
      formatter: (cell) => {
        const formattedTime = moment(cell, "hh:mm A", true);
        if (!formattedTime.isValid()) {
          return <>{'Invalid Time'}</>;
        }
        return <>{formattedTime.format("hh:mm A")}</>;
      },

    },
    {
      dataField: "userName",
      text: "Username",
    },
    {
      dataField: "dealerShipName",
      text: "Dealership Name",
    },

    {
      dataField: "email",
      text: "Dealer Email",
    },
    {
      dataField: "mobileNo",
      text: "Dealer Mobile No.",
    },
    {
      dataField: "discription",
      text: "Description",
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.discription}</span>
          )}
        </div>
      )
    },
    {
      dataField: "address",
      text: "Address",
      
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.address}</span>
          )}
        </div>
      )
    },

    {
      dataField: "country",
      text: "Country",
    },
    {
      dataField: "state",
      text: "State",
    },
    {
      dataField: "city",
      text: "City",
    },
    
    {
      dataField: "pinCode",
      text: "Pin Code",
    },
    {
      dataField: "siteType",
      text: "Site Type",
    },
   

  ];

  // ----- No. of Records to be displayed
  const customTotal = (from, to, size) => (
    <div>
      Showing {totaloffset + from} to {totaloffset + to} of {size} entries
    </div>
  );

  return (
    <>
      {isLoaded ? (
        <div className="reportload"></div>
      ) : (
        <>

          <Row>
            <Col md={{ span: 3, order: 1 }} className="mb-3" xs={{ order: 2 }}>
              <div className="form-group">
                
              <label>From Date</label>
                <DatePicker
                  selected={fromDate}
                  onChange={handleFromDateChange}
                  dateFormat="dd-MMM-yyyy" 
                  maxDate={new Date()} 
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown 
                  scrollableYearDropdown 
                />
              </div>
            </Col>
            <Col md={{ span: 3, order: 2 }} className="mb-3" xs={{ order: 3 }}>
              <div className="form-group">
              <label>To Date</label>
                <DatePicker
                  selected={toDate}
                  onChange={handleToDateChange}
                  dateFormat="dd-MMM-yyyy" 
                  minDate={fromDate} 
                  maxDate={new Date()} 
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown 
                  scrollableYearDropdown 
                />
              </div>
            </Col>
            <Col md={{ span: 3, order: 3 }} className="mb-3" xs={{ order: 4 }}>
              <button
                className="btn btn-secondary mt-lg-4"
                onClick={getDealerListByDate}
              >
                <FontAwesomeIcon icon={faSearch} className="me-2" />
                <span>Search By Date</span>{" "}
              </button>
            </Col>
            <Col md={{ span: 3, order: 4 }} className="mt-4" xs={{ order: 1 }}>
              <div className="newadd" align="right">
                <Link to="dealer-entry" className="btn btn-secondary">
                  <FontAwesomeIcon icon={faPlus} className="me-2" />
                  <span>Add Dealer Entry</span>{" "}
                </Link>
              </div>
            </Col>
          </Row>
          <ToolkitProvider
            keyField="id"
            search={true}
            columns={columns}
            data={entries}
            exportCSV={{ onlyExportFiltered: true, exportAll: true }}
          >
            {({ baseProps, searchProps, csvProps }) => (
              <Paginator.PaginationProvider
                pagination={Pagination({
                  custom: true,
                  disablePageTitle: true,
                  alwaysShowAllBtns: true,
                  totalSize: totalCount,
                  paginationTotalRenderer: customTotal,
                  onPageChange: handlePageChange,
                  // sizePerPageRenderer: customSizePerPage,
                })}
              >
                {({ paginationProps, paginationTableProps }) => (
                  <Card>
                    <div className="table-responsive py-2">
                      <Card.Header>
                        <Row>
                          <Col xs={12} md={6} className="py-1">
                                                  <h5 className="head mb-2">Dealer Entry list</h5></Col>
                          <Col
                            xs={12}
                            md={6}
                            className="d-flex justify-content-md-end py-1"
                          >
                            <button
                              className="btn btn-secondary"
                              // ----- Function call to download dealer pdf
                              onClick={DealerEntryPdfDownload}
                            >
                              <FontAwesomeIcon
                                icon={faDownload}
                                className="me-2"
                              />
                              <span>PDF</span>{" "}
                            </button>
                            <button
                              className="btn btn-secondary mx-2"
                              // ----- Function call to download dealer excel
                              onClick={getDealerExcelDownload}
                            >
                              <FontAwesomeIcon
                                icon={faDownload}
                                className="me-2"
                              />
                              <span>Excel</span>
                            </button>
                          </Col>
                        </Row>
                      </Card.Header>
                      <Table
                        {...baseProps}
                        {...paginationTableProps}
                        bodyClasses="border-0"
                        rowClasses="border-bottom"
                        classes="table-flush dataTable-table"
                        wrapperClasses="table-responsive"
                        filter={filterFactory()}
                        remote={{ pagination: true }}
                        headerClasses="header-class"
                        hover
                        striped
                        // condensed
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                          afterSaveCell: (oldValue, newValue, row, column) => {
                            const changeRowData = {
                              selectedRow: row,
                              cellChange: newValue,
                              columnChange: column,
                            };
                            var newRowData = JSON.parse(
                              JSON.stringify(changeRowData)
                            );
                            setChangeRowData(newRowData);
                            return { async: true };
                          },
                        })}
                      // selectRow={selectRow}
                      />
                      <Card.Footer>
                        <Row>
                          <Col
                            xs={12}
                            md={6}
                            className="d-flex align-items-center py-1"
                          ></Col>
                          <Col
                            xs={12}
                            md={6}
                            className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                          >
                            <Paginator.PaginationListStandalone
                              {...paginationProps}
                            />
                          </Col>
                        </Row>
                      </Card.Footer>
                    </div>
                  </Card>
                )}
              </Paginator.PaginationProvider>
            )}
          </ToolkitProvider>
        </>
      )}
    </>
  );
};
